import { courses } from './courses'
import { getPriorityCourseSeo } from './courseSeo'
import { buildTime } from './clock'
import { buildMeta } from './metaTags'
import { socialImagePath } from './socialImages'
import { getStaticPageByPath } from './staticPages'

export function buildNotFoundMeta(pathname: string) {
  return buildMeta({
    title: 'Page Not Found — Skillo Academy',
    description: "The page you're looking for doesn't exist or has been moved.",
    path: pathname,
    noindex: true,
  })
}

export function buildCourseMeta(slug: string | undefined) {
  const course = courses.find((item) => item.slug === slug)
  if (!course) {
    return buildNotFoundMeta(`/courses/${slug ?? ''}`)
  }

  const courseSeo = getPriorityCourseSeo(course.slug)
  return buildMeta({
    title: courseSeo?.seoTitle ?? `${course.title} — Skillo Academy`,
    description: courseSeo?.seoDescription ?? course.description,
    path: `/courses/${course.slug}`,
    image: socialImagePath(`/courses/${course.slug}`),
  })
}

export function buildStaticPageMeta(pathname: string) {
  const page = getStaticPageByPath(pathname, buildTime())
  if (!page) {
    return buildNotFoundMeta(pathname)
  }

  return buildMeta({
    title: page.title,
    description: page.metaDescription,
    path: page.path,
    image: socialImagePath(page.path),
  })
}
